import { createFileRoute } from "@tanstack/react-router";
import { ProofsIndexPage } from "@/features/proofs/ProofsIndexPage";

export const Route = createFileRoute("/_app/proofs/")({ component: ProofsIndexPage });
